import { Router } from '@vaadin/router';
import { LitElementStateService } from '@stefanholzapfel/lit-state';
import {State} from "../views/loading/loading";

export class RouterService {
    public static init(outlet: HTMLElement): RouterService {
        if (!RouterService.initialized) {
            RouterService.router = new Router(outlet);
            RouterService.router.setRoutes(RouterService.getRouteConfig());
            RouterService.setRouteChangeListener();
            RouterService.initialized = true;
            if (RouterService.activeGlobalError) {
                RouterService.navigate('/error');
            }
            return RouterService;
        } else {
            console.log('Already initialized RouterService!');
        }
    }
    
    private static router;
    private static currentRoute;
    private static previousRoute = null;

    static initialized = false;
    static activeGlobalError;

    static navigate(route: string): void {
        Router.go(route);
    }
    
    static getPreviousRoute(): string | null {
        return RouterService.previousRoute;
    }
    
    static getCurrentRoute(): string {
        return RouterService.currentRoute;
    }

    private static setRouteChangeListener() {
        window.addEventListener(
            'vaadin-router-location-changed',
            event => {
                RouterService.previousRoute = RouterService.currentRoute;
                RouterService.currentRoute = (event as any).detail.location.pathname;
                LitElementStateService.getGlobalInstance<State>().set({
                    app: {
                        previousRoute: RouterService.previousRoute,
                        currentRoute: RouterService.currentRoute
                    }
                });
            }
        );
    }
    
    private static getRouteConfig(): {}[] {
        return [
            {
                path: '/detail',
                action: () => {
                    import('../views/app-layout/pages/detail/detail');
                },
                component: 'lit-detail'
            },
            {
                path: '/form',
                action: () => {
                    import('../views/app-layout/pages/form/form');
                },
                component: 'lit-form'
            },
            {
                path: '/list',
                action: async (context, commands) => {
                    import('../views/app-layout/pages/list/list');
                },
                component: 'lit-list'
            },
            {
                path: '/error',
                action: async (context, commands) => {
                    import('../views/app-layout/pages/error/error');
                },
                component: 'lit-error'
            },
            {
                path: '(.*)',
                redirect: '/form'
            }
        ];
    }
}
